import { createSlice } from '@reduxjs/toolkit';
import {
  addSubject,
  editSubject,
  fetchAllSubjects,
  fetchSubjectById,
  removeSubject,
  updateDefaultSubjectInSettings,
} from './actions';

const initialState = {
  subjects: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  currentSubject: {
    step: 0,
    type: 'simple',
    title: '',
    description: '',
    contain: [],
    mustContain: [],
    mustNotContain: [],
    parsedQuery: '',
    isDefault: false,
    loading: false,
    error: null,
  },
  addOrEditRequest: {
    loading: false,
    error: null,
  },
  selectedSubjectIds: [],
  removeSubjects: {
    loading: false,
    error: null,
  },
  updateDefaultSubject: {
    successful: false,
    error: null,
  },
};

export const subjectSlice = createSlice({
  name: 'subjectSlice',
  initialState,
  reducers: {
    setSubjectParamValue: (state, action) => {
      const { key, value } = action.payload;
      state.currentSubject[key] = value;
    },
    setSelectedSubjectIds: (state, action) => {
      state.selectedSubjectIds = action.payload;
    },
    resetSubjectState: (state) => {
      state.currentSubject = initialState.currentSubject;
    },
    resetRemoveSubjectsError: (state) => {
      state.removeSubjects.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateDefaultSubjectInSettings.fulfilled, (state) => {
        state.updateDefaultSubject.successful = true;
      })
      .addCase(fetchAllSubjects.pending, (state) => {
        state.subjects.data = [];
        state.subjects.loading = true;
        state.subjects.error = null;
      })
      .addCase(fetchAllSubjects.rejected, (state, action) => {
        state.subjects.error = action.payload;
      })
      .addCase(fetchAllSubjects.fulfilled, (state, action) => {
        const { subjects, total } = action.payload;
        state.subjects.data = subjects;
        state.subjects.total = total;
        state.subjects.loading = false;
        state.subjects.error = null;
      })
      .addCase(fetchSubjectById.fulfilled, (state, action) => {
        state.currentSubject = action.payload;
        state.currentSubject.loading = false;
        state.currentSubject.error = null;
      })
      .addCase(fetchSubjectById.pending, (state) => {
        state.currentSubject.loading = true;
        state.currentSubject.error = null;
      })
      .addCase(fetchSubjectById.rejected, (state, action) => {
        state.currentSubject.error = action.payload;
      })
      .addCase(removeSubject.pending, (state) => {
        state.removeSubjects.loading = true;
        state.removeSubjects.error = null;
      })
      .addCase(removeSubject.rejected, (state, action) => {
        state.removeSubjects.loading = false;
        state.removeSubjects.error = action.payload;
      })
      .addCase(removeSubject.fulfilled, (state) => {
        state.removeSubjects.loading = false;
        state.removeSubjects.error = null;
      })
      .addCase(addSubject.pending, (state) => {
        state.addOrEditRequest.loading = true;
        state.addOrEditRequest.error = null;
      })
      .addCase(addSubject.rejected, (state, action) => {
        state.addOrEditRequest.loading = false;
        state.addOrEditRequest.error = action.payload;
      })
      .addCase(addSubject.fulfilled, (state) => {
        state.addOrEditRequest.loading = false;
        state.addOrEditRequest.error = null;
      })
      .addCase(editSubject.pending, (state) => {
        state.addOrEditRequest.loading = true;
        state.addOrEditRequest.error = null;
      })
      .addCase(editSubject.rejected, (state, action) => {
        state.addOrEditRequest.loading = false;
        state.addOrEditRequest.error = action.payload;
      })
      .addCase(editSubject.fulfilled, (state) => {
        state.addOrEditRequest.loading = false;
        state.addOrEditRequest.error = null;
      });
  },
});

export const {
  setSelectedSubjectIds,
  resetSubjectState,
  setSubjectParamValue,
  resetRemoveSubjectsError,
} = subjectSlice.actions;
